import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { canViewOrganization } from 'util/organizationAccess';
import Dashboard from './default';

const RoleBasedDashboard = () => {
  const userRoles = useSelector(state => state.authentication?.userRoles ?? []);

  if (canViewOrganization(userRoles)) {
    return <Navigate to="/admin" replace />;
  }
  return <Dashboard />;
};

export default RoleBasedDashboard;
